const $       = require('jquery');
const user    = require('./user');

const api = {};

let theme = loadTheme() ? loadTheme() : systemTheme();
applyTheme(theme);
watchTheme();

user.onSignIn(() => {
  if (loadTheme()) {
    unapplyTheme(theme);
    applyTheme(theme = loadTheme());
  }
});

window.addEventListener('storage', e => {
  if (e.key === storeKey()) {
    unapplyTheme(theme);
    applyTheme(theme = e.newValue);
  }
});

Object.defineProperty(api, 'val', {
  get() {
    return theme.replace(/\.system$/, '');
  },
  set(value) {
    if (!value || value === theme) return;

    switch (value) {
      case 'system':
        unapplyTheme(theme);
        applyTheme(theme = systemTheme());
        saveTheme(theme);
        break;
      case 'light':
      case 'dark':
      case 'dark.inverted':
        unapplyTheme(theme);
        applyTheme(theme = value);
        saveTheme(theme);
        break;
    }
  }
});

function watchTheme() {
  if ('matchMedia' in window) {
    const darkThemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      if (/system$/.test(theme)) {
        api.theme = 'system';
      }
    };
    if ('addEventListener' in darkThemeMediaQuery) {
      darkThemeMediaQuery.addEventListener('change', handler);
    } else if ('addListener' in darkThemeMediaQuery) {
      darkThemeMediaQuery.addListener(handler);
    }
  }
}

function systemTheme() {
  if ('matchMedia' in window) {
    const darkThemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    return darkThemeMediaQuery.matches ? 'dark.system' : 'light.system';
  } else {
    return 'light.system';
  }
}

function applyTheme(value) {
  value.split('.').forEach(t => {
    $('html').addClass(`${t}-theme`);
  });
}

function unapplyTheme(value) {
  value.split('.').forEach(t => {
    $('html').removeClass(`${t}-theme`);
  });
}

function loadTheme() {
  return localStorage.getItem(storeKey());
}

function saveTheme(value) {
  localStorage.setItem(storeKey(), value);
}

function storeKey() {
  return `${user.id || 'anonymous'}_theme`;
}

module.exports = api;

